import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import "./Disclaimer.css";
import { Header } from "../Header-Assesment/Header";
import { useNavigate } from 'react-router-dom';
import LearnMore from "./LearnMore.pdf"

export const DisclaimerTemplete = ({
  headerTitle,
  headerSubtitle,
  breadcrumbs,
}) => {
  
  const navigate = useNavigate(); // Initialize useNavigate

  const handleAgreeClick = () => {
    navigate("/Assessment/maincontent/physical");
  };


return (
  <div className="maincontent-Dis">
    <div className="header-assessment">
      <Header title={headerTitle} subtitle={headerSubtitle} />
    </div>
    <div className="toppart">
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, i) => (
          <React.Fragment key={i}>
            {crumb.icon && (
              <FontAwesomeIcon
                icon={crumb.icon}
                style={{ color: "#c1c0bd" }}
              />
            )}
            <p className={crumb.active ? "element-text3" : "element-text"}>
              {crumb.text}
            </p>
            {i !== breadcrumbs.length - 1 && <p className="overline">/</p>}
          </React.Fragment>
        ))}
      </div>
    </div>
        <div className="div-maindis">
          <div className="ass-dis">
            <div className="frame-110">
              <div className="frame-111">
                <div className="frame-112">
                  <div className="frame-113">
                  <FontAwesomeIcon icon={faCircleExclamation} />
                    <div className="distext" style={{fontFamily:'Inter'}}>Important Disclaimer</div>
                  </div>
                  <p className="para">
                  The mindsherpa PEARLI assessment is designed for informational purposes only and your participation is anonymous. It does not offer any diagnostic measurements or treatment advice and should not be considered a substitute for professional mental health care. This platform is supported by a volunteer base, and while we strive for accuracy and helpfulness, the insights provided are not a substitute for the expertise of qualified mental health professionals. Always consult a licensed mental health professional if you are going through a crisis or need medical attention. Please be aware that due to the anonymous and volunteer nature of this assessment, we cannot provide individual follow-up or personalized support based on your responses.

                  </p>
                </div>
                <div className="frame-114">
                  <a href={LearnMore} className="learn-more-dis">
                    <label>
                    Learn More
                    </label>
                  </a>
                  <button className="agree-dis" onClick={handleAgreeClick}>
                    <label>
                    I agree
                    </label>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>



</div>

      )
    };